import PropTypes from 'prop-types';
import React from "react";
import HowieHeader from "~app/components/HowieHeader";

const FooterPageLayout = ({ mainRef, children }) => (
  <React.Fragment>
    <HowieHeader />
    <main
      role="main"
      className="FooterPageLayout__content"
      ref={mainRef}
      tabIndex="-1"
    >
      {children}
    </main>
  </React.Fragment>
);

FooterPageLayout.propTypes = {
  mainRef: PropTypes.func.isRequired,
};

export default FooterPageLayout;



// WEBPACK FOOTER //
// ./src/components/layouts/FooterPageLayout.js